import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { AppBrowserModule } from './app/app.browser.module';

if (environment.production) {
  enableProdMode();
}

// Prevent duplicate bootstrap and handle loading state
function bootstrapApp() {
  // Check if already bootstrapped
  if (window['angularBootstrapComplete']) {
    return;
  }
  
  window['angularBootstrapComplete'] = true;
  
  // Bootstrap the app
  platformBrowserDynamic().bootstrapModule(AppBrowserModule)
    .then(() => {
      // Add loaded class to prevent FOUC
      const appRoot = document.querySelector('dc-root');
      if (appRoot) {
        appRoot.classList.add('app-loaded');
      }
    })
    .catch(err => console.error(err));
}

// Check if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapApp);
} else {
  // DOM is already loaded, bootstrap immediately
  bootstrapApp();
}
